/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Injectable, inject } from '@angular/core'
import { Observable, of } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { ProfileService, PublicProfile } from '../../../../../apps/myprofile-ui/src/app/services/profile/profile.service'
import { PhoneCommunicationDto, PhoneService } from '../../../../../apps/myprofile-ui/src/app/services/phone/phone.service'

@Injectable({
  providedIn: 'root',
})
export class MyProfilePreferredCommunicationChannelService {
  private profileService = inject(ProfileService)
  private phoneService = inject(PhoneService)

  public getProfile(country = 'DE', locale = 'de-DE'): Observable<PublicProfile | null> {
    return this.profileService.getProfile(country, locale).pipe(catchError(() => of(null)))
  }

  public updatePreferredCommunicationData(country: string, locale: string, payload: PublicProfile) {
    return this.profileService.updateProfile(country, locale, payload).pipe(catchError(() => of(null)))
  }

  public getPhoneList(country = 'DE', locale = 'de-DE'): Observable<PhoneCommunicationDto[] | null> {
    return this.phoneService.getPhoneList(country, locale).pipe(catchError(() => of(null)))
  }
}
